module.exports = __webpack_public_path__ + "img/eventtype-unknown.422aa33a.svg";